export enum PauseOrderTypes {
  NONE,
  ONEHOUR,
  TWOHOURS,
  THREEHOURS,
  ONEDAY = 24
}
